import { IUserSettingsInitialValues } from '../../../types';

export const INITIAL_VALUES: IUserSettingsInitialValues = {
  id: undefined,
  email: '',
  first_name: '',
  last_name: '',
  position: '',
  department: '',
  phone_number: '',
  address: '',
  role: 0,
  organization: 0,
  created_at: '',
  created_by: '',
};
